import type { ChangeEvent, FunctionComponent } from 'react';
import React from 'react';

import { Col, Row } from 'src/components/ui';
import Form from 'src/components/ui/Form';

import whoamiOptions from '../../data/whoamiOptions';
import type { UpdateFieldType } from '../contactForm/ContactForm';
import style from '../contactForm/ContactForm.module.scss';

import type { ContactFormData } from 'src/models/contact';

import { INVALID_INPUT_FORMAT } from 'src/utils/Message.Utils';
import { mergeClassNames } from 'src/utils/ReactUtils';

type RequestCommercialPartnerFormType = {
  updateField: UpdateFieldType;
  formValue: ContactFormData;
};

const RequestCommercialPartnerForm: FunctionComponent<
  RequestCommercialPartnerFormType
> = ({ updateField, formValue }) => {
  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Group controlId="whoami">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Vous êtes
            </Form.Label>
            <Form.Control
              value={formValue.whoami}
              as="select"
              required
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                updateField(e, Number(e.target.value))
              }
              name="whoami"
            >
              <option value="">Sélectionnez...*</option>
              {whoamiOptions.map((whoamiOption) => (
                <option key={whoamiOption.id} value={whoamiOption.id}>
                  {whoamiOption.title}
                </option>
              ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group controlId="countCar">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Nombre de véhicules
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Nombre de véhicules *"
              required
              pattern={'^[0-9]*$'}
              onChange={updateField}
              value={formValue.countCar}
              name="countCar"
            />
            <Form.Control.Feedback type="invalid">
              {!formValue?.countCar?.length
                ? 'Ce champ est obligatoire.'
                : 'Le format est invalide'}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group controlId="resume">
            <Form.Label
              className={mergeClassNames([
                style.contactFormLabel,
                style.contactFormLabelRequired,
              ])}
            >
              Résumé
            </Form.Label>
            <Form.Control
              placeholder="Résumé *"
              required
              onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
                const { value } = event.target;
                if (value.length < 20 || value.length > 500) {
                  event.target.setCustomValidity(INVALID_INPUT_FORMAT);
                } else {
                  event.target.setCustomValidity('');
                }
                updateField(event);
              }}
              as="textarea"
              rows={3}
              value={formValue.resume}
              name="resume"
            />
            <Form.Control.Feedback type="invalid">
              {!formValue?.resume?.length
                ? 'min 20 caractères - max 500 caractères'
                : 'Le format est invalide'}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
};

export default RequestCommercialPartnerForm;
